import { Injectable } from '@angular/core';

import { FILTER_TYPE } from '../models/filter-type';
import { KeyValue } from '../models/key-value';

/**
 * This service filter the optionList passed to select or autocomplete components. Can filter by value, key and value or key
 */
@Injectable()
export class SelectAutocompleteService {
    filterOptions(options: KeyValue[], filterType: number, searchText: string): KeyValue[] {
        switch (filterType) {
            case FILTER_TYPE.BY_VALUE:
                return this.filterByField(options, 'value', searchText);
            case FILTER_TYPE.BY_KEY:
                return this.filterByField(options, 'key', searchText);
            case FILTER_TYPE.BY_VALUE_OR_KEY:
                return this.filterByFields(options, ['value', 'key'], searchText);
            default:
                return [];
        }
    }

    filterByField(options: KeyValue[], field: string, searchText: string): KeyValue[] {
        return options.filter((option: KeyValue) => option[field as keyof KeyValue].includes(searchText));
    }

    filterByFields(options: KeyValue[], fields: string[], searchText: string): KeyValue[] {
        return options.filter(
            (option: KeyValue) =>
                option[fields[0] as keyof KeyValue].includes(searchText) || option[fields[1] as keyof KeyValue].includes(searchText)
        );
    }
}
